import React, { FC, useState, useEffect, useContext, useCallback } from "react";
import { styled } from "@mui/material/styles";
import { Drawer } from "@mui/material";
import { HomeModelsContext } from "@contexts";
import { LeftPanel } from "../LeftPanel";
import { RightPanel } from "../RightPanel";
import { Footer, Header } from "@components";
import { Outlet } from "react-router-dom";
import { CityBar, SelectedCountry } from "../CityBar";

const LayoutContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  minHeight: "100vh", backgroundColor: "#0b0b0e", color: "#e8e8ec",
}));

const ContentWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexGrow: 1,
}));

const SidebarLeft = styled("div")(({ theme }) => ({
  width: 240,
  flexShrink: 0,
  position: "sticky",
  top: 0,
  alignSelf: "flex-start",
  height: "100vh",
  overflowY: "auto",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": { display: "none" },
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const RightColumn = styled("div")({
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
});

const SidebarRight = styled("div")(({ theme }) => ({
  width: 240,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const MainContent = styled("main")(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  overflow: "auto",
}));

const StyledFooter = styled("footer")(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#0b0b0e", borderTop: "1px solid rgba(255,255,255,.08)",
  textAlign: "center",
}));

export type MainLayoutProps = {
  children?: React.ReactNode | React.ReactNode[];
};

const MainLayout: FC<MainLayoutProps> = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { homeModels } = useContext(HomeModelsContext);
  const [selectedCountry, setSelectedCountry] =
    useState<SelectedCountry | null>(null);

  const handleMobileMenuClose = useCallback(() => {
    console.log("1234");
    return setIsMobileMenuOpen(false);
  }, []);
  const handleMobileMenuOpen = useCallback(() => {
    console.log("open mobile menu");
    return setIsMobileMenuOpen(true);
  }, []);

  return (
    <LayoutContainer>
      <SidebarLeft>
        <LeftPanel
          showSearch
          onCloseMobileMenu={handleMobileMenuClose}
          onCountrySelect={setSelectedCountry}
        />
      </SidebarLeft>

      <RightColumn>
        <Header onCountriesClick={handleMobileMenuOpen} />

        <ContentWrapper>
          <MainContent>
            {/* Drawer mobile con filtros por pais (LeftPanel) */}
            <Drawer
              anchor="left"
              open={isMobileMenuOpen}
              onClose={handleMobileMenuClose}
              keepMounted
              PaperProps={{ sx: { width: 300 } }}
            >
              <LeftPanel
                onCloseMobileMenu={handleMobileMenuClose}
                onCountrySelect={setSelectedCountry}
              />
            </Drawer>

            <CityBar country={selectedCountry} />
            <Outlet />
          </MainContent>

          <SidebarRight>
            <RightPanel />
          </SidebarRight>
        </ContentWrapper>

        <StyledFooter>
          <Footer />
        </StyledFooter>
      </RightColumn>
    </LayoutContainer>
  );
};

export { MainLayout };
